import WebIcon from '@material-ui/icons/Web';
import labels from '../../labels';
import CmsList from './CmsList';

export default {
  name: 'cms',
  list: CmsList,
  icon: WebIcon,
  options: {
    label: labels.cms
  }
};
